// extracted by mini-css-extract-plugin
export var acitonButtons = "_af-0";
export var additionalIcon = "_af-f";
export var block = "_af-1";
export var blockContent = "_af-7";
export var blockDescription = "_af-8";
export var blockIcon = "_af-9";
export var blockTitle = "_af-6";
export var border = "_af-a";
export var center = "_af-l";
export var edge = "_af-b";
export var edgeLabel = "_af-c";
export var edgePath = "_af-d";
export var error = "_af-e";
export var flowchart = "_af-g";
export var flowchartContent = "_af-h";
export var highlighted = "_af-3";
export var hover = "_af-4";
export var icon = "_af-i";
export var left = "_af-m";
export var navButton = "_af-j";
export var navButtons = "_af-k";
export var right = "_af-n";
export var selected = "_af-2";
export var small = "_af-5";